export default __webpack_public_path__ + "static/media/customizedApproachDeco.7a8d435a.png";